"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsEventGroupEnum = void 0;
var AnalyticsEventGroupEnum;
(function (AnalyticsEventGroupEnum) {
    AnalyticsEventGroupEnum["PLATFORM_NAME"] = "platform_name";
    AnalyticsEventGroupEnum["COMPANY_ID"] = "company_id";
    AnalyticsEventGroupEnum["COMPANY_NAME"] = "company_name";
    AnalyticsEventGroupEnum["COUNTRY"] = "country";
    AnalyticsEventGroupEnum["OS_NAME"] = "os_name";
    AnalyticsEventGroupEnum["PROJECT_ID"] = "project_id";
})(AnalyticsEventGroupEnum || (exports.AnalyticsEventGroupEnum = AnalyticsEventGroupEnum = {}));
